/**
 * Custom error types for quota and application errors
 */

export class QuotaExceededError extends Error {
  constructor(
    public quotaType: 'cv_generation' | 'vacancy_save' | 'cover_letter',
    public remaining: number
  ) {
    super(`Quota exceeded for ${quotaType}. Remaining: ${remaining}`);
    this.name = 'QuotaExceededError';
  }
}
